import { Component, Element, h, Host, Prop, State } from '@stencil/core'
import { ResizeObserver } from 'resize-observer'

@Component({
  tag: 'ui-resizing-text',
})
export class Resizer {
  @Element() el: HTMLUiResizingTextElement

  @Prop() transitionIn = false
  @Prop() multiline = false

  @State() textWidth = this.transitionIn ? '0' : null
  @State() textHeight = null

  resizeObserver: ResizeObserver
  _contentEl: HTMLSpanElement
  get contentEl() {
    return this._contentEl
  }
  set contentEl(value: HTMLSpanElement) {
    if (this._contentEl) {
      this.resizeObserver.unobserve(this._contentEl)
    }
    if (value) {
      this.resizeObserver.observe(value)
    }
  }

  componentWillLoad() {
    this.resizeObserver = new ResizeObserver(([entry]) => {
      this.textWidth = entry.contentRect.width + 'px'
      if (this.multiline) {
        this.textHeight = entry.contentRect.height + 'px'
      }
    })
  }

  render() {
    return (
      <Host
        class='inline-block overflow-hidden transition-all duration-200'
        style={{
          width: this.textWidth,
          height: this.textHeight,
        }}
      >
        <span class='inline-block' ref={(el) => (this.contentEl = el)}>
          <slot />
        </span>
      </Host>
    )
  }
}
